import React from "react";

function Shipping() {
  return (
    <main>
      <section className="mb-50 mt-5">
        <div className="container">
          <div className="title-section">
            <h1 className="heading heading-decor fw-bold">Shipping  and Payment Policy</h1>
          </div>
          <h5 className="fw-bold mt-4">Shipping Policy</h5>
          <p>
            <ul>
             <li> 1· Aahilya Creations will ensure that the products are delivered in an excellent condition and in the fastest time possible. All orders are shipped within 4-5 working days of placing the order and it usually takes another 3-10 working days for domestic orders (India) to reach your door steps (subject to transit conditions).
              </li>

      <li>2· International order takes up to 10 - 15 working days to be delivered.</li>
      <li>3· Although we strive hard to deliver the orders in the given turnaround time (2-5 working days for the ready fabrics) and (7-10 working days for customized order), however there could be rare instances wherein the order could get delayed due to circumstances beyond our control.</li>
      <li>4· For products that require separate shipping charges, shall be indicated in the product detail page and while the order is being placed.</li>
      <li>5· We can process only one shipping address per order, hence if you would like to ship products to multiple addresses then you are required to place separate orders.</li>
            <li>6· All the taxes and duties for international orders will be borne by the customers.</li>
            <li>7· Amount mentioned on the payment page will be the final amount.</li>
            <li>8· Prices are inclusive of all charges and taxes (terms n conditions apply).</li>
            <li>9· Delivery of an order shall be completed when the goods are delivered to the address you give us.</li>
            <li>10· The delivery days mentioned is approximate only. Since we rely on our courier partners for delivery, this can vary due to factors that are outside our control.</li>
            <li>11· Once your order has been shipped, you will receive an email notification with the courier and tracking details so that you can track your order online.</li>
            <li>12· Please be advised, that we do not offer express delivery. Though it can be arranged on request with extra fee.</li>
            <li>13· By placing the order from www.aahilya.com website you authorize our logistics partner to get in touch with you for any concern regarding their services.</li>
            <li>14· Customs once applied shall be borne by the customer. For return of an international order, the amount of the customs applied will be deducted from the total refundable amount.</li>
            </ul>
          
          </p>
          <h5 className="fw-bold mt-4">Payment Policy</h5>
          <p>We at Aahilya Creations are committed towards maintaining the highest standards of security so as to ensure that our most important asset our customers shopping experience is private, safe and secure. Hence, all Credit Card, Debit Card, Paypal, Wallets, EMI and Net Banking transactions are processed using a secure encrypted connection to keep your transaction details confidential at all times.</p>
        <p>All payments made against the purchases/services on www.aahilya.com by you shall be as against the MRP displayed on the website and shall be in terms and conditions of the third party Online Payment Gateway Services as adopted and applicable to your transaction as approved by Aahilya Creations.</p>
        <p>While availing any of the payment method/s offered by us, we are not responsible or take no liability of whatsoever nature in respect of any loss or damage arising directly or indirectly to you including but not limited to the following:</p>
            <ul>
              <li>1· Lack of authorization for any transaction/s.</li>
              <li>2· Exceeding the preset limit mutually agreed by you and between your banks.</li>
              <li>3· Any payment issues arising out of the transaction.</li>
              <li>4· Decline of transaction for any other reason/s.</li>
           
            </ul>
            <p>
            You can select the following mode of payments to pay for your orders:-
            <ul>
            <li>1· Net Banking.</li>

<li>2· Visa/Master - Credit & Debit Cards.</li>

<li>3· American Express - Credit Cards.</li>

<li>4· Paypal</li>

<li>5· Razorpay</li>

<li>6· Wallets</li>

<li>7· Cash on Delivery (COD) - available on select Pin Codes.</li>

<li>8. EMI on select credit cards.</li>

<li>9· Other Payment gateway mentioned in our website.</li>
            </ul>
          </p>
    <p>So, select your convenient payment option and shop with confidence at your trusted shopping site</p>
    <p>By placing your order you agree to AAHILYA CREATIONS terms and conditions of use fully, totally, absolutely and completely.</p>
    <p>Have a question? Chat with us, or e-mail us at <a href="mailto:info@aahilya.com" >info@aahilya.com</a> or call/WhatsApp us at <a href="+91-92893 70407" >+91-92893 70407</a>. We’d be happy to answer any question</p>
       
        </div>
      </section>
    </main>
  );
}

export default Shipping;
